<template>
	<v-layout justify-center align-center class="countdown-wrapper" id="countdown-box">
		<v-row v-if="isInFuture">
			<v-col cols="12">
				<h1 class="countdown-title">{{$t('countDown.switchingOnAfter')}}</h1>
			</v-col>
			<v-col cols="12">
				<v-row class="counter-row">
					<v-col cols="2" class="py-0"><p class="time-text">{{time.day}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-text">{{time.hour}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-text">{{time.minute}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-text">{{time.second}}</p></v-col>
				</v-row>
				<v-row class="counter-row">
					<v-col cols="2" class="py-0"><p class="time-label">{{labels.day}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-label">{{labels.hour}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-label">{{labels.minute}}</p></v-col>
					<v-col cols="2" class="py-0"><p class="time-label">{{labels.second}}</p></v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row v-else>
			<v-col cols="12">
<!--				<h1 class="countdown-title">{{$t('countDown.thereAre')}}</h1>-->
        <p class="time-label mb-4 px-2">{{ $t('countDown.lastYearCount') }}
          <span class="highlight-text">16.000</span>
          {{ $t('countDown.lights') }}
        </p>
        <p class="time-label">{{ $t('countDown.thisYearCount') }}</p>
			</v-col>
			<v-col cols="12">
				<v-row class="counter-row">
					<p class="time-text">{{lightsCount}}</p>
				</v-row>
				<v-row class="counter-row">
					<p class="time-label">{{$t('countDown.lights')}}</p>
				</v-row>
			</v-col>
		</v-row>
	</v-layout>
</template>

<script>
	require('moment-countdown');
	let moment = require('moment');

	export default {
		name: "CountDown",
		data() {
			return {
				timer: '',
				diff: null,
				interval: null,
				eventStartDate: moment('2021-12-04 18:00'),
				lightsCount: '17.200',
				snowFallInterval: null,
				signalEmitted: false,
				time: {
					day: '',
					hour: '',
					minute: '',
					second: ''
				},
				labels: {
					day: 'dni',
					hour: 'ur',
					minute: 'minut',
					second: 'sekund'
				}
			}
		},
		created() {
			const vm = this;

			vm.countDown();
		},
		mounted() {
			const vm = this;

		},
		destroyed() {
			const vm = this;

			clearTimeout(vm.interval);
			vm.interval = null;
		},
		computed: {
			isInFuture() {
				const vm = this;

				return vm.diff <= 0;
			}
		},
		methods: {
			countDown() {
				const vm = this;

				let endString = '';

				const count = vm.eventStartDate.countdown();

				vm.diff = count.value;

				if (vm.diff > 0 && !vm.signalEmitted) {
					vm.$emit('onExpired');
					vm.signalEmitted = true;
				}

				vm.time.day = count.days;

				if (count.days === 1) vm.labels.day = vm.$t('countDown.oneDay');
				else if (count.days === 2) vm.labels.day = vm.$t('countDown.twoDays');
				else vm.labels.day = vm.$t('countDown.moreDays');

				vm.time.hour = count.hours;

				if (count.hours === 1) vm.labels.hour = vm.$t('countDown.oneHour');
				else if (count.hours === 2) vm.labels.hour = vm.$t('countDown.twoHours');
				else if (count.hours === 3 || count.hours === 4) vm.labels.hour = vm.$t('countDown.fourHours');
				else vm.labels.hour = vm.$t('countDown.moreHours');

				vm.time.minute = count.minutes;

				if (count.minutes === 1) vm.labels.minute = vm.$t('countDown.oneMinute');
				else if (count.minutes === 2) vm.labels.minute = vm.$t('countDown.twoMinutes');
				else if (count.minutes === 3 || count.minutes === 4) vm.labels.minute = vm.$t('countDown.fourMinutes');
				else endString += vm.labels.minute = vm.$t('countDown.moreMinutes');

				vm.time.second = count.seconds;

				if (count.seconds === 1) vm.labels.second = vm.$t('countDown.oneSecond');
				else if (count.seconds === 2) vm.labels.second = vm.$t('countDown.twoSeconds');
				else if (count.seconds === 3 || count.seconds === '4') vm.labels.second = vm.$t('countDown.fourSeconds');
				else vm.labels.second = vm.$t('countDown.moreSeconds');

				//vm.timer = count.toString();
				vm.timer = endString;

				clearTimeout(vm.interval);
				vm.interval = setTimeout(() => vm.countDown(), 200);
			}
		}
	}
</script>

<style lang="scss">
	.countdown-wrapper {
		//background-color: #EF4758;
		background-color: rgba(255, 255, 255, 0.12);
		border-radius: 20px;
		//width: 60%;
		//height: 60%;
	}

	.countdown-title {
		color: white;
		text-align: center;
		//font-family: 'Charm' !important;
	}

	.counter-row {
		text-align: center;
		align-items: center;
		justify-content: center;
	}

	.time-text {
		color: white;
		font-size: 30px;
		font-weight: bold;
		margin-bottom: 0 !important;
	}

	.time-label {
		color: white;
		font-weight: lighter;
		font-size: 17px;
		margin-bottom: 0 !important;
	}

  .highlight-text {
    font-weight: bold;
    font-size: 20px;
  }

	.snowflake-item {
		animation: fall linear forwards;
		color: #ffffff;
		position: absolute;
		top: -20px;
	}

	@keyframes fall {
		to {
			transform: translateY(70vh);
		}
	}

	/* Extra small devices (phones, 600px and down) */
	@media only screen and (max-width: 600px) {
		.snowflake-item {
			animation: fall linear forwards;
			color: #ffffff;
			position: absolute;
			top: 300px;
		}
	}

	/* Small devices (portrait tablets and large phones, 600px and up) */
	@media only screen and (min-width: 600px) {

	}

	/* Medium devices (landscape tablets, 768px and up) */
	@media only screen and (min-width: 768px) {

	}

	/* Large devices (laptops/desktops, 992px and up) */
	@media only screen and (min-width: 992px) {

	}
</style>
